import React, { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Text from '../Text/Text';
import EmptyAvatar from '../../assets/images/emptyAvatar.png';
import { MEDIA_URL } from '../../constants/api';
import CustomDropdownMenu from '../CustomDropdownMenu/CustomDropdownMenu';
import ButtonDropdownMenuItem from '../ButtonDropdownMenuItem/ButtonDropdownMenuItem';
import postLogout from '../../thunks/auth/logout';
import FaceLoginModal from '../FaceLoginModal/FaceLoginModal';
import routes from '../../router/routes';
import { IconOutside, IconReload, IconUser } from '../../assets/icon';

const UserHeader = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visible, toggleVisible] = useState(false);
  const [isFaceLoginVisible, setIsFaceLoginVisible] = useState(false);
  const {
    getMyProfile: {
      user: {
        name,
        avatar
      } = {}
    },
  } = useSelector((state) => ({
    getMyProfile: state.getMyProfile,
  }), shallowEqual);

  const onUserClick = () => toggleVisible(!visible);

  const onLogout = () => {
    dispatch(postLogout());
    setTimeout(() => navigate('/'), 1000);
  };

  return (
    <>
      <CustomDropdownMenu
        toggleVisible={toggleVisible}
        show={visible}
        drop="down"
        containerStyle="max-w-[200px]"
        headerComponent={(
          <div
            className="flex flex-row justify-center items-center px-[10px] py-[5px]
            transition-all duration-300 ease-out rounded-[5px] hover:cursor-pointer
            hover:bg-input-focus dark:hover:bg-[#415a77]"
            role="presentation"
            onClick={onUserClick}
          >
            <Text muted text="Hi, " textStyle="text-[13px] mr-[4px]" />
            <Text text={`${name || 'User'}`} textStyle="text-[13px]" />
            <div className="ml-[10px]">
              <img
                src={avatar ? `${MEDIA_URL}/${avatar}` : EmptyAvatar}
                alt="avatar"
                className="w-[35px] h-[35px] rounded-[5px]"
              />
            </div>
          </div>
        )}
      >
        <ButtonDropdownMenuItem
          text="My Profile"
          onClick={() => navigate('/profile')}
          leftIcon={<IconUser className="w-[18px] h-[18px]" />}
        />
        <ButtonDropdownMenuItem
          text="Switch User by Face"
          onClick={() => {
            toggleVisible(false);
            setIsFaceLoginVisible(true);
          }}
          leftIcon={<IconReload className="w-[18px] h-[18px]" />}
        />
        <ButtonDropdownMenuItem
          text="Sing Out"
          onClick={onLogout}
          danger
          leftIcon={<IconOutside className="w-[18px] h-[18px]" />}
        />
      </CustomDropdownMenu>
      <FaceLoginModal
        visible={isFaceLoginVisible}
        title="Switch User by Face"
        subTitle="Capture or upload another user's face photo to switch the current session."
        onClose={() => setIsFaceLoginVisible(false)}
        onAuthenticated={() => {
          toggleVisible(false);
          navigate(routes.DASHBOARD);
        }}
      />
    </>
  );
};

export default UserHeader;
